/**
 * Return a list of selectable schedule options
 *
 * @param  {Object} state
 * @return {Array}
 */
const scheduleOptions = state => state.data.map(i => {
    return {
        key: i.id,
        label: i.name
    }
})

/**
 * Determine if there are schedules in the dataset
 *
 * @param  {Object} state
 * @return {Boolean}
 */
const hasAvailableSchedules = state => state.data.length > 0

export default {
    scheduleOptions,
    hasAvailableSchedules
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/form/lease-up-schedules/getters.js